import styled from 'styled-components';
import { Button } from 'antd';

export const RulerWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  &.ruler-horizontal {
    left: 30px;
    width: calc(100% - 30px);
    height: 30px;
    border-bottom: 1px solid #dadce0;
  }
  &.ruler-vertical {
    top: 30px;
    width: 30px;
    height: calc(100% - 30px);
    border-right: 1px solid #dadce0;
  }
  .ruler-guideliness {
    .scena-display-drag {
      background-color: #00c4cc;
      color: #fff;
      padding: 2px;
      border-radius: 4px;
    }
    .scena-guide {
      background-color: #00c4cc;
    }
  }
`;

export const PopupContainer = styled.div`
  min-width: 240px;
  max-width: 250px;
  padding: 15px;
  position: relative;
  .ant-input {
    margin-bottom: 12px;
    color: #555555;
    font-size: 14px;
    font-weight: 600;
  }
  .ant-input:placeholder-shown {
    font-size: 12px;
    font-weight: normal;
  }
  .ant-calendar-picker {
    .ant-calendar-picker-icon {
      margin-top: -12px;
    }
  }
`;

export const PopupActionContainer = styled.div`
  display: flex;
  margin-top: 10px;
`;

export const SaveButton = styled(Button)`
  font-weight: 600;
  display: flex;
  align-items: center !important;
  background: #000 !important;
  border-radius: 4px !important;
  color: #ffffff !important;
  border: 2px solid transparent !important;
  border-radius: 15px !important;
  &:hover,
  &:focus {
    background: #000 !important;
    color: #ffffff !important;
    border-color: transparent !important;
    box-shadow: initial !important;
  }
`;

export const CancelButton = styled(Button)`
  font-weight: 600 !important;
  display: flex !important;
  align-items: center !important;
  background: #000 !important;
  border-radius: 4px !important;
  color: #fff !important;
  border: 1px solid #b1afaf !important;
  margin-right: 10px !important;
  border-radius: 15px !important;
  &:hover,
  &:focus {
    background: #000 !important;
    color: #fff !important;
    border: 1px solid #b1afaf !important;
    box-shadow: initial !important;
  }
`;

export const PopupLabel = styled.div`
  color: rgb(49 70 89 / 0.9);
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 5px;
`;

export const RefTag = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: ${props => (props.isFillableElement ? 'center' : 'space-between')};
  z-index: 1;
  font-size: 14px;
  background: #00c4cc;
  color: #fff;
  height: 26px;
  padding: ${props => (props.isFillableElement ? '15px 12px 15px 12px' : '0 10px 0 25px')};
  margin: 0 10px 10px 0;
  text-decoration: none;
  &::before {
    background: #fff;
    border-radius: 10px;
    box-shadow: inset 0 1px rgba(0, 0, 0, 0.25);
    content: '';
    height: 6px;
    left: 10px;
    position: absolute;
    width: 6px;
    top: 10px;
  }
  .anticon.anticon-setting {
    font-size: ${props => props.isFillableElement && '15px'};
  }
  &::before {
    display: ${props => props.isFillableElement && 'none'};
  }
  p {
    font-size: 14px;
  }
  i.anticon {
    padding-left: 15px;
  }
  .fillablePopup {
    position: relative;
  }
`;

export const DateVar = styled.div`
  position: absolute;
  top: ${props => (props.isEmail ? '10px' : 0)};
  background: transparent;
  width: ${props => (props.width ? `${props.width}px` : 0)};
  height: ${props => (props.height ? `${props.height}px` : 0)};
  font-size: ${props => (props.messageStudio ? '0.96vw' : '15px')};
  @media (max-aspect-ratio: 3/4) {
    font-size: ${props => (props.messageStudio && '17px')};
  }
  @media (min-aspect-ratio: 4/3) {
    font-size: ${props => (props.messageStudio && '17px')};
    @media (max-width: 1460px) {
      font-size: ${props => (props.messageStudio && '13px')};
    }
  }
  @media (min-aspect-ratio: 3/4) and (max-aspect-ratio: 1/1) {
    font-size: ${props => (props.messageStudio && '15px')};
  }
  @media (min-aspect-ratio: 1/1) and (max-aspect-ratio: 4/3) {
    font-size: ${props => (props.messageStudio && '11px')};
  }
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .edit-button {
    background: rgb(37,41 ,45);
    color: #fff;
    height: 90%;
    padding-inline: 5px;
    place-content: center;
    border-radius: 2px;
  }
`;

export const RadioButtonSection = styled.div`
  width: ${props => props.staticTableBlock ? '' : '100%'};
  height: ${props => props.childWidthGreaterThanParent ? '100%' : props.staticTableBlock ? '' : '100%'};
  aspect-ratio: ${props => props.staticTableBlock && '1 / 1'};
  display: flex;
  .ant-radio-wrapper,
  .ant-radio,
  .ant-radio-inner {
    height: 100%;
    width: 100%;
  }
  .ant-radio-group {
    width: 100%;
  }
  label {
    width: 100%;
    height: 100%;
  }
  .ant-radio-wrapper {
    margin-right: 0;
  }
  .ant-radio-inner::after {
    top: 0;
    left: 0;
    margin: 25%;
    width: 50%;
    height: 50%;
    border-radius: 50%;
  }
  .ant-radio-inner {
    background: ${props => props.backgroundColor || '#fff'} !important;
    border-color: ${props => props.borderColor || '#000'} !important;
    border-radius: 50%;
  }

  .ant-radio-checked .ant-radio-inner {
    &::after {
      border: ${props => props.staticTableBlock ? '' : '2px solid #fff'};
      border-color: ${props => `${props.color || '#000'} !important`};
      background-color: ${props => `${props.color || '#000'} !important`};
    }
  }
`;

export const CheckBoxSection = styled.div`
  width: ${props => props.staticTableBlock ? '100%' : '100%'};
  height: ${props => props.childWidthGreaterThanParent ? '100%' : props.staticTableBlock ? '' : '100%'};
  aspect-ratio: ${props => props.staticTableBlock && '1 / 1'};
  display: flex;
  .anticon {
    margin-top: 3px;
  }
  label {
    width: 100%;
    height: 100%;
  }
  .ant-checkbox {
    display: inline;
  }

  &.complex-documents {
    .ant-checkbox {
      top: 0;
    }
  }

  .ant-checkbox,
  .ant-checkbox-inner {
    width: 100%;
    height: 100%;
  }
  .ant-checkbox-inner {
    border: 2px solid black;

    &::after {
      position: absolute;
      top: 42%;
      left: 28%;
      width: 30%;
      height: 60%;
      border: 2px solid #fff;
      border-color: ${props => `${props.color || '#fff'} !important`};
      border-top: 0;
      border-left: 0;
      content: ' ';
    }
  }
  .ant-checkbox .ant-checkbox-inner {
    background-color: ${props => `${props.backgroundColor || '#fff'} !important`};
    border-color: ${props => `${props.borderColor || '#fff'} !important`};
  }
  &.crossBox {
    .ant-checkbox .ant-checkbox-inner {
      background-color: ${props =>
        `${props.backgroundColor ? props.backgroundColor : '#000'} !important`};
      border-color: ${props => `${props.borderColor ? props.borderColor : '#000'} !important`};
      position: relative;
    }
    .ant-checkbox-checked .ant-checkbox-inner:before,
    .ant-checkbox-checked .ant-checkbox-inner:after {
      position: absolute;
      left: 46%;
      top: 25%;
      content: ' ';
      height: 50%;
      width: 2px;
      background-color: ${props => `${props.color || '#fff'} !important`};
      border-color: ${props => `${props.color || '#fff'} !important`};
      opacity: 1;
      font-size: 13px;
    }
    .ant-checkbox-inner:before {
      transform: rotate(45deg);
    }
    .ant-checkbox-inner:after {
      transform: rotate(-45deg);
    }
  }
  &.squareBox {
    .ant-checkbox .ant-checkbox-inner {
      /*background-color: #fff !important;
      border-color: #000 !important;*/
      background-color: ${props => `${props.backgroundColor || '#fff'} !important`};
      border-color: ${props => `${props.borderColor || '#000'} !important`};
      position: relative;
    }
    .ant-checkbox-checked .ant-checkbox-inner:before {
      position: absolute;
      content: ' ';
      height: 35%;
      width: 35%;
      background-color: ${props => `${props.color || '#000'} !important`};
      border-color: ${props => `${props.color || '#000'} !important`};
      opacity: 1;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    .ant-checkbox-inner:after {
      display: none !important;
    }
  }
  &.circleBox {
    .ant-checkbox .ant-checkbox-inner {
      /*background-color: #fff !important;
      border-color: #000 !important;*/
      background-color: ${props => `${props.backgroundColor || '#fff'} !important`};
      border-color: ${props => `${props.borderColor || '#000'} !important`};
      position: relative;
    }
    .ant-checkbox-checked .ant-checkbox-inner:before {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      content: ' ';
      height: 35%;
      width: 35%;
      background-color: ${props => `${props.color || '#000'} !important`};
      border-color: ${props => `${props.color || '#000'} !important`};
      opacity: 1;
      border-radius: 100%;
    }
    .ant-checkbox-inner:after {
      display: none !important;
    }
  }
`;
